<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">Deals Automatically Synced</h3>
      </b-card-header>
      <b-card-body>
        <div>
          <p>In this section you can choose which Deal Stages you would like automatically synced to ClarityNOW. By default all stages are synced.</p>
          <b-tabs content-class="mt-3">
            <b-tab :title="pipeline.name" v-for="pipeline in pipelines" :key="pipeline.id">
              <b-row>
                <b-col v-for="stage in pipeline.stages" :key="stage.id">
                  <base-input :label="stage.name" :label-for="stage.name">
                    <base-switch class="mr-1" v-model="stage.active" @input="saveActive"></base-switch>
                  </base-input>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">Deal Stages Mapping</h3>
      </b-card-header>
      <b-card-body>
        <div>
          <p>In this section you can map your Deal Stages to ClarityNOW Pipeline, Listing, or Transaction statuses. By default deals are saved under the ClarityNOW Custom Field chosen in a deal.</p>
          <b-tabs content-class="mt-3">
            <b-tab :title="pipeline.name" v-for="(pipeline, index) in mapping" :key="pipeline.id">
              <b-list-group class="w-100">
                <b-list-group-item>
                  <b-row>
                    <b-col>
                      <strong>FUB Stage</strong>
                    </b-col>
                    <b-col>
                    </b-col>
                    <b-col>
                      <strong>ClarityNOW Status</strong>
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item v-for="(stage, key) in pipeline.stages" :key="stage.id" v-if="pipelines[index].stages[key].active">
                  <b-row>
                    <b-col>
                      {{ stage.name }}
                    </b-col>
                    <b-col>
                      <i class="fas fa-arrow-right"></i>
                    </b-col>
                    <b-col>
                      <el-select v-model="stage.clarity_status" placeholder="Select a Status" @change="saveDealMapping(pipeline.id, stage)">
                        <el-option-group label="Pipeline">
                          <el-option value="Nurture" label="Nurture"></el-option>
                          <el-option value="Appt Set" label="Appt Set"></el-option>
                          <el-option value="Appt Held" label="Appt Held"></el-option>
                          <el-option value="Agreement Signed" label="Agreement Signed"></el-option>
                          <el-option value="Listing Taken" label="Listing Taken"></el-option>
                          <el-option value="Sold" label="Sold"></el-option>
                          <el-option value="Out" label="Out"></el-option>
                        </el-option-group>
                        <el-option-group label="Listings">
                          <el-option value="coming-soon" label="Coming Soon"></el-option>
                          <el-option value="active" label="Active"></el-option>
                          <el-option value="cancelled" label="Cancelled"></el-option>
                          <el-option value="expired" label="Expired"></el-option>
                        </el-option-group>
                        <el-option-group label="Transactions">
                          <el-option value="pending" label="Pending"></el-option>
                          <el-option value="closed" label="Closed"></el-option>
                          <el-option value="failed" label="Failed"></el-option>
                        </el-option-group>
                      </el-select>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-tab>
          </b-tabs>
        </div>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">Daily Tracking Mapping</h3>
      </b-card-header>
      <b-card-body>
        <p>In this section you can map your Appointment Types to ClarityNOW Daily Tracking fields. By default the only Daily Tracking events that are synced are Dials, Contacts, Listing Appointments Set (Listing Appointment Type in FUB) and Buyer Appointments Set (Buyer consultation Appointment Type in FUB).</p>
        <b-list-group>
          <b-list-group-item>
            <b-row>
              <b-col>
                <strong>FUB Appointment Type</strong>
              </b-col>
              <b-col></b-col>
              <b-col>
                <strong>ClarityNOW Daily Tracking Fields</strong>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item v-for="type in appointmentTypes" :key="type.id">
            <b-row>
              <b-col>
                {{ type.name }}
              </b-col>
              <b-col>
                <i class="fas fa-arrow-right"></i>
              </b-col>
              <b-col>
                <el-select v-model="type.clarity_field" placeholder="Select a Tracking Source" @change="saveTrackingField(type)">
                  <el-option v-for="(source, key) in trackingSources" :value="source.value" :label="source.label" :key="key"></el-option>
                </el-select>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import {Select, OptionGroup, Option} from 'element-ui';
import trackingSources from './trackingSources';

export default {
  components: {
    [Select.name]: Select,
    [OptionGroup.name]: OptionGroup,
    [Option.name]: Option
  },
  data() {
    return {
      pipelines: null,
      pipeline: null,
      mapping: null,
      appointmentTypes: null,
      trackingSources: trackingSources,
      trackingMapping: []
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    }),
  },
  methods: {
    async getPipelines() {
      await axios.get(this.userRoute + "/integrations/fub/settings/stages/active")
      .then(response => {
        this.pipelines = response.data;
      })
      .catch(error => {
        // error
      });
    },
    async saveActive() {
      await axios.post(this.userRoute + "/integrations/fub/settings/stages/active", this.pipelines)
      .then(response => {
        this.getPipelines();
      })
      .catch(error => {
        // error
      });
    },
    async getStageMapping() {
      await axios.get(this.userRoute + "/integrations/fub/settings/stages")
      .then(response => {
        this.mapping = response.data;
      })
      .catch(error => {
        // error
      });
    },
    async saveDealMapping(pipeline, stage) {
      await axios.post(this.userRoute + "/integrations/fub/settings/stages", {
        pipeline: pipeline,
        stage: stage.id,
        status: stage.clarity_status
      })
      .then(response => {

      })
      .catch(error => {
        // error
      });
    },
    async getAppointmentTypes() {
      await axios.get(this.userRoute + "/integrations/fub/settings/tracking")
      .then(response => {
        this.appointmentTypes = response.data;
      })
      .catch(error => {
        // error
      });
    },
    async getCustomTrackingSources() {
      await axios.get(this.userRoute + "/tracking-sources")
      .then(response => {
        response.data.forEach((source) => {
          this.trackingSources.push({value: source.slug, label:source.name });
        });
      })
      .catch(error => {
        // error
      });
    },
    async saveTrackingField(source) {
      await axios.post(this.userRoute + "/integrations/fub/settings/tracking", source)
      .then(error => {
        this.getCustomTrackingSources();
      })
      .catch(error => {
        // error
      });
    },

  },
  created() {
    this.getPipelines();
    this.getStageMapping();
    this.getAppointmentTypes();
    this.getCustomTrackingSources();
  }
};
</script>